import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { useOnboarding } from '@/pages/Onboarding/context';
import {
  DominateOptionItemSprite,
  DominateOptionItemSpriteList,
} from '@/pages/Onboarding/Layouts/OwnAI_Dominate/components/DominateOptionItemSprite';
import { TOOLS_OPTIONS } from '@/pages/Onboarding/options/Tools/TOOLS_OPTIONS';
import { ToolsOptionIdType } from '@/pages/Onboarding/options/Tools/types';
import { getToolsChoiceTitleById } from '@/pages/Onboarding/options/Tools/utils/getToolsChoice';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../components/Title';
import { LayoutDataType } from '../../types';

import { PageStyles } from './Tools.styles';

export const ScreenTools: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Tools',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const tools = form.watch('tools');

  const handleSelect = (option: OnbOptionType<LayoutDataType['tools']>) => {
    form.setValue('tools', option.id);
  };

  const getImageSrc = (id: OnbOptionType<ToolsOptionIdType>['id']) => {
    return `/assets/layout-own-ai-dominate/tools/${id}.png`;
  };

  const handleBack = () => {
    wizard.goToStep('safeword_input');
  };

  const handleNextStep = () => {
    userService.createOrUpdate({
      onboarding_data: {
        tools: getToolsChoiceTitleById(tools),
      },
    });
    wizard.nextStep();
  };

  return (
    <PageStyles background={'domination'}>
      <OnboardingNavigation onBack={handleBack} />
      <OwnAiTitle>
        She doesn’t need tools… but she loves them. Which one does she always
        keep close?
      </OwnAiTitle>

      <IonContent>
        <DominateOptionItemSpriteList>
          {TOOLS_OPTIONS.map((option) => (
            <DominateOptionItemSprite
              key={option.id}
              alt="tools"
              isSelected={tools === option.id}
              onClick={() => handleSelect(option)}
              spriteSrc={getImageSrc(option.id)}
              title={option.title}
              subtitle={option.subtitle}
              TEST_ID={`tools-${option.id}`}
            />
          ))}
        </DominateOptionItemSpriteList>
      </IonContent>

      {tools && (
        <OnboardingFooter
          onContinue={handleNextStep}
          buttonColor={'red-gradient'}
          buttonRadius={'sm'}
          buttonSize={'medium'}
        />
      )}
    </PageStyles>
  );
};
